export const metricsMessagesEn = {
  'metrics.projectNotSelected.title': 'No project selected',
  'metrics.projectNotSelected.description': 'Please select a project',
  'metrics.batchNotSelected.title': 'No batch selected',
  'metrics.batchNotSelected.description': 'Please select a batch',
  //metrics dashboard
  'metrics.dashboard.title': 'Dashboard',
  'metrics.dashboard.annotatorDropdown.label': 'Annotators',
  'metrics.dashboard.annotatorDropdown.allAnnotators': 'All annotators',
  'metrics.dashboard.overallProgress.title': 'Overall progress',
  'metrics.dashboard.overallProgress.pending.label': 'Pending',
  'metrics.dashboard.overallProgress.completed.label': 'Completed',
  'metrics.dashboard.batchProgress.datepicker.label.start': 'Start date',
  'metrics.dashboard.batchProgress.datepicker.label.end': 'End date',
  'metrics.dashboard.batchProgress.tab.chart': 'Chart',
  'metrics.dashboard.batchProgress.tab.table': 'Table',
  'metrics.dashboard.batchProgress.pending.label': 'Pending',
  'metrics.dashboard.batchProgress.completed.label': 'Completed',
  'metrics.dashboard.batchProgress.title': 'Batch-wise progress',
  'metrics.dashboard.batchProgress.yAxis.label': 'Count',
  'metrics.dashboard.batchProgress.xAxis.label': 'Batches',

  'metrics.summary.title': 'Summary',
  'metrics.summary.email.modal.title': 'Send summary report via email',
  'metrics.summary.email.modal.addEmail.description':
    'Add email addresses of stakeholders to send the summary report based on current filters',
  'metrics.summary.email.modal.addEmail.instruction':
    'Press Enter or click Add to include an email',
  'metrics.summary.email.modal.addEmail.button': 'Add',
  'metrics.summary.email.modal.attachmentDetails.title': 'Attachment details',
  'metrics.summary.email.modal.attachmentDetails.content':
    'Summary report ({batchType} batch) from {startDate} to {endDate}',
  'metrics.summary.email.modal.sendEmail.loading.text': 'Sending email...',
  'metrics.summary.email.modal.sendEmail.cancelButton': 'Cancel',
  'metrics.summary.email.modal.sendEmail.confirmButton': 'Send email',
  'metrics.summary.email.modal.sendEmail.error': 'Failed to send email.',

  'metrics.batch.title': 'Batch',

  'metrics.encounterStats.title': 'Encounter statistics',

  'metrics.irrScore.title': 'F1 score',
  'metrics.irrScore.typeFilter.label': 'Type',
  'metrics.irrScore.datepicker.label': 'Date',
  'metrics.irrScore.cards.initialP0': 'Initial p0',
  'metrics.irrScore.cards.currentP0': 'Current p0',
  'metrics.irrScore.cards.pe': 'Pe',
  'metrics.irrScore.cards.initialF1Measure': 'Initial F1',
  'metrics.irrScore.cards.currentF1Measure': 'Current F1',

  'metrics.holidays.title': 'Holidays',
};
